export default "__VITE_ASSET__SG6nf9iz__"